import { useMemo } from "react";
import styles from "./SectionDurationBadge.module.scss";
import { useSectionClock } from "./SectionClockContext";
import { parseDurationToSeconds } from "./utils";
export { parseDurationToSeconds, deriveDurationStatus } from "./utils";

const formatCountdown = (totalSeconds) => {
  const s = Math.round(totalSeconds);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  return h > 0 ? `${String(h).padStart(2, "0")}:${mm}:${ss}` : `${mm}:${ss}`;
};

const statusConfig = {
  ON_TRACK: { label: "On Track", cls: styles.onTrack },
  OVERDUE: { label: "Overdue", cls: styles.overdue },
  COMPLETED_WITHIN_TIME: {
    label: "Completed in Time",
    cls: styles.completedInTime,
  },
};

const SectionDurationBadge = ({
  started_at,
  completed_at,
  expected_duration,
}) => {
  const now = useSectionClock();

  const durationSecs = useMemo(
    () => parseDurationToSeconds(expected_duration),
    [expected_duration],
  );

  // Memoized — started_at / completed_at never change while an order is mounted
  const startedAtMs = useMemo(
    () => (started_at ? new Date(started_at).getTime() : null),
    [started_at],
  );
  const completedAtMs = useMemo(
    () => (completed_at ? new Date(completed_at).getTime() : null),
    [completed_at],
  );

  if (!startedAtMs || !durationSecs) return null;

  const refTime = completedAtMs ?? now;
  const elapsedSeconds = (refTime - startedAtMs) / 1000;
  const remainingSeconds = durationSecs - elapsedSeconds;

  const status = completedAtMs
    ? remainingSeconds >= 0
      ? "COMPLETED_WITHIN_TIME"
      : "OVERDUE"
    : remainingSeconds >= 0
      ? "ON_TRACK"
      : "OVERDUE";

  const config = statusConfig[status];

  return (
    <div className={styles.wrapper}>
      <span className={`${styles.badge} ${config.cls}`}>{config.label}</span>
      {!completedAtMs && remainingSeconds > 0 && (
        <span className={`${styles.countdown} ${styles.onTrack}`}>
          {formatCountdown(remainingSeconds)} remaining
        </span>
      )}
    </div>
  );
};

export default SectionDurationBadge;
